var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgApple = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.844 14.293a9.79 9.79 0 0 1-.968 1.74c-.509.725-.925 1.227-1.246 1.506-.498.458-1.032.692-1.603.706-.41 0-.904-.117-1.48-.354-.577-.235-1.108-.352-1.593-.352-.509 0-1.054.117-1.638.352-.585.237-1.056.36-1.416.373-.548.023-1.093-.218-1.638-.725-.348-.303-.783-.823-1.304-1.56-.56-.786-1.019-1.699-1.379-2.739C2.193 12.117 2 11.03 2 9.976c0-1.206.26-2.246.783-3.118.41-.7.956-1.253 1.64-1.659a4.41 4.41 0 0 1 2.216-.625c.434 0 1.005.135 1.714.399.707.265 1.16.4 1.36.4.148 0 .653-.157 1.507-.471.809-.291 1.49-.411 2.05-.364 1.514.122 2.652.72 3.408 1.795-1.354.82-2.024 1.97-2.01 3.444.012 1.149.428 2.105 1.247 2.863a4.1 4.1 0 0 0 1.247.818c-.1.29-.206.568-.318.835ZM13.371.625c0 .9-.33 1.741-.985 2.519-.79.925-1.748 1.46-2.785 1.375a2.803 2.803 0 0 1-.021-.341c0-.864.376-1.79 1.044-2.545a4.02 4.02 0 0 1 1.272-.956c.514-.25 1-.388 1.456-.412.013.12.019.24.019.36Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5.265h18v18H.5z"
  })))));
});
SvgApple.displayName = "SvgApple";
export default SvgApple;